
import { Vue, Options } from 'vue-class-component'
import SvgIcon from './SvgIcon.vue'
import { Bookmark } from '@/utils/typedef'

@Options({
  components: {
    SvgIcon
  },
  props: [
    'bookmark', 'callback'
  ]
})
export default class BookmarkEdit extends Vue {
  bookmark!: Bookmark
  content: Bookmark = {
    name: '新书签'
  }

  callback!: (data: Bookmark | null) => void

  mounted (): void {
    this.content = JSON.parse(JSON.stringify(this.bookmark))

    const container = this.$refs.box
    if (container instanceof HTMLElement) {
      const input = container.querySelector('input') as HTMLInputElement
      if (input) {
        input.focus()
        input.select()
      }
      container.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
          this.confirmConfig()
        } else if (event.key === 'Escape') {
          this.cancelConfig()
        } else if (event.key === 'Tab') {
          console.log('Tab pressed')
          this.shiftFoucus(event)
        }
      })
    }
  }

  shiftFoucus (event: KeyboardEvent): void {
    const box = this.$refs.box as HTMLElement
    const inputs = box.querySelectorAll('input')
    const index = Array.from(inputs).findIndex(input => input === event.target)
    if (index >= 0) {
      const nextIndex = (index + 1) % inputs.length
      console.log('index:', index, nextIndex, inputs.length)
      inputs[nextIndex].focus()
      inputs[nextIndex].select()
    }
  }

  confirmConfig () {
    // check the content
    if (this.content.name.trim() === '') {
      this.callback(null)
      return
    }
    this.callback(this.content)
  }

  cancelConfig () {
    this.callback(null)
  }

  copyContent ($event: MouseEvent) {
    let target = $event.target as HTMLElement
    if (target.tagName.toUpperCase() !== 'SVG') {
      target = target.parentElement as HTMLElement
    }
    const input = target.previousElementSibling as HTMLInputElement
    if (input === null || input.tagName.toUpperCase() !== 'INPUT') return
    // copy the content without using the execCommand API
    navigator.clipboard.writeText(input.value).then(() => {
      input.focus()
      input.select()
    }).catch(err => {
      console.error('Failed to copy: ', err)
    })
  }
}
